import React from "react";
import { useHistory } from "react-router-dom";

const NotAllowedPage = () => {
    const history = useHistory();

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            height: "80vh",
                            backgroundColor: "#f8f9fa",
                            fontFamily: "Arial, sans-serif",
                            textAlign: "center",
                            padding: "20px",
                        }}
                    >
                        <h1 style={{ fontSize: "4rem", margin: "0", color: "#dc3545" }}>403</h1>
                        <h2 style={{ marginTop: "10px", fontSize: "2rem", color: "#333" }}>
                            Access Denied
                        </h2>
                        <p style={{ marginTop: "10px", fontSize: "1.1rem", color: "#555" }}>
                            You do not have permission to access this page.
                        </p>

                        {/* <button
                            onClick={() => history.push("/")}
                            style={{
                                marginTop: "20px",
                                padding: "10px 20px",
                                backgroundColor: "#007bff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontSize: "1rem",
                            }}
                        >
                            Go Back Home
                        </button> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotAllowedPage;
